import { render, staticRenderFns } from "./OneClickConfig2.vue?vue&type=template&id=2ce5ffdf&scoped=true&"
import script from "./OneClickConfig2.vue?vue&type=script&lang=js&"
export * from "./OneClickConfig2.vue?vue&type=script&lang=js&"
import style0 from "./OneClickConfig2.vue?vue&type=style&index=0&id=2ce5ffdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5ffdf",
  null
  
)

export default component.exports